import { Box, Slider, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const MIN_FONT_SIZE = 12;
const MAX_FONT_SIZE = 64;

const dispatchClosePicker = e => {
  e.stopPropagation();
  try {
    window.dispatchEvent(new CustomEvent('styleEditor:closePicker'));
  } catch (err) {}
};

const FontSizeControl = ({ value, onChange }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Slider
        value={value}
        min={MIN_FONT_SIZE}
        max={MAX_FONT_SIZE}
        onMouseDown={dispatchClosePicker}
        onChange={(_e, next) => onChange(next)}
        sx={{
          flex: 1,
          color: theme.palette.primary.greySecound,
          height: 4,
          '& .MuiSlider-thumb': {
            width: 14,
            height: 14,
          },
        }}
      />
      <TextField
        value={value}
        onMouseDown={dispatchClosePicker}
        onChange={e => {
          const next = Number(e.target.value);
          if (!Number.isNaN(next)) {
            onChange(Math.min(MAX_FONT_SIZE, Math.max(MIN_FONT_SIZE, next)));
          }
        }}
        size="small"
        sx={{
          width: 48,
          '& .MuiOutlinedInput-root': {
            height: '28px',
            fontSize: theme.typography.customFontSize[1],
            borderRadius: theme.shape.customBorderRadius[0],
          },
          '& input': {
            padding: '0 4px',
            textAlign: 'center',
          },
        }}
      />
      <Typography
        sx={{
          fontSize: theme.typography.customFontSize[1],
          color: theme.palette.primary.greySecound,
        }}
      >
        px
      </Typography>
    </Box>
  );
};

export default FontSizeControl;
